<template>
  <mdb-modal removeBackdrop size="md" :show="showModal" @close="handleClose">
    <mdb-modal-header class="text-center" color="indigo">
      <mdb-modal-title tag="h4" bold class="w-100 text-white">{{
        $t("edit")
      }}</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body class="mx-3" color="white">
      <mdb-autocomplete
        v-model="currentChain"
        :data="chainIdList"
        :label="$t('chain')"
      />
      <mdb-input :label="$t('retailers_name')" v-model="retailerName" />
    </mdb-modal-body>
    <mdb-modal-footer center>
      <mdb-btn @click="copyRetailers" color="indigo"
        >{{ $t("copy") }}</mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import {
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalBody,
  mdbInput,
  mdbModalFooter,
  mdbModalTitle,
  mdbAutocomplete,
} from "mdbvue";

export default {
  name: "DataTableCopyModal",
  props: {
    modalshow: Boolean,
    selectedIds: Array,
  },
    data: () => ({
    showModal: false,
    currentChainId: null,
    retailerName: "",
    chainIdList: [],
    currentChain: "",
  }),
  mounted() {
+    this.fetchData()
  },
  methods: {
    handleClose() {
      this.showModal = !this.showModal;
    },
    copyRetailers() {
      var n = this.currentChain.lastIndexOf(',');
      this.currentChainId = this.currentChain.substring(n + 1);
      this.$emit("copyRetailers", this.currentChainId, this.retailerName);
    },
    fetchData() {
        this.$http
        .get("/1.0/front/retailers/chains")
        .then((response) => {
          if (response.status == 200) {
            response.data["chains"].forEach(element => {
              this.chainIdList.push(element.name + "," + element.id)
            });
            this.$emit("load-ready");
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          } else {
            this.$notify.error({
              message: this.$t("content_not_loaded"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          }
          this.$notify.removeAll();
        })
        .catch((error) => {
          this.$notify.removeAll();
          this.$root.$emit("session_failed");
          return error;
        })
        .finally();
    }
  },
  components: {
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbInput,
    mdbModalFooter,
    mdbModalTitle,
    mdbAutocomplete
  },
  watch: {
    modalshow() {
      this.showModal = !this.showModal;
    },
  },
};
</script>
